import type { SVGProps } from "react";

import { Finn } from "./components/Finn";
import { Wordmark } from "./components/Wordmark";

/** Outline icon in the heyfinn.ai line style: 24-unit grid, round caps. */
const LineIcon = ({
  color = "currentColor",
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  />
);

export const UserIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.95125 0.0201972C11.2051 0.215646 13.1306 2.25809 13.2799 4.44712C13.6033 9.14768 7.70243 11.5175 4.58285 7.91635C1.46327 4.3152 3.96092 0.36712 7.75715 0.0201972C8.06563 -0.00912021 8.6378 -0.00423398 8.95125 0.0201972Z"
      fill={fill}
    />
    <path
      d="M4.05545 9.6705C5.12517 9.58255 5.60778 10.3106 6.49838 10.721C7.90642 11.366 9.32441 11.3269 10.6976 10.6184C11.4489 10.2324 11.9365 9.6021 12.8619 9.66073C15.3397 9.82687 16.4293 12.055 16.8024 14.1805C17.2701 16.8239 17.1358 19.6238 13.8172 20H3.16983C0.119908 19.6335 -0.228371 17.3175 0.100006 14.7571C0.38858 12.4947 1.39361 9.89527 4.06043 9.6705H4.05545Z"
      fill={fill}
    />
  </svg>
);

export const ScheduleIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <LineIcon className={className} color={fill} width="20" height="20">
    <rect x="3" y="5" width="18" height="16" rx="2.5" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </LineIcon>
);

export const CompanyIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.16667 0C1.01196 0 0.863584 0.0607827 0.754188 0.168977C0.644791 0.277171 0.583333 0.423914 0.583333 0.576923C0.583333 0.729933 0.644791 0.876675 0.754188 0.984869C0.863584 1.09306 1.01196 1.15385 1.16667 1.15385V13.8462H0.583333C0.428624 13.8462 0.280251 13.9069 0.170854 14.0151C0.0614581 14.1233 0 14.2701 0 14.4231C0 14.5761 0.0614581 14.7228 0.170854 14.831C0.280251 14.9392 0.428624 15 0.583333 15H13.4167C13.5714 15 13.7198 14.9392 13.8291 14.831C13.9385 14.7228 14 14.5761 14 14.4231C14 14.2701 13.9385 14.1233 13.8291 14.0151C13.7198 13.9069 13.5714 13.8462 13.4167 13.8462H12.8333V1.15385C12.988 1.15385 13.1364 1.09306 13.2458 0.984869C13.3552 0.876675 13.4167 0.729933 13.4167 0.576923C13.4167 0.423914 13.3552 0.277171 13.2458 0.168977C13.1364 0.0607827 12.988 0 12.8333 0H1.16667ZM4.66667 2.88462C4.51196 2.88462 4.36358 2.9454 4.25419 3.05359C4.14479 3.16179 4.08333 3.30853 4.08333 3.46154C4.08333 3.61455 4.14479 3.76129 4.25419 3.86948C4.36358 3.97768 4.51196 4.03846 4.66667 4.03846H5.83333C5.98804 4.03846 6.13642 3.97768 6.24581 3.86948C6.35521 3.76129 6.41667 3.61455 6.41667 3.46154C6.41667 3.30853 6.35521 3.16179 6.24581 3.05359C6.13642 2.9454 5.98804 2.88462 5.83333 2.88462H4.66667ZM4.08333 5.76923C4.08333 5.61622 4.14479 5.46948 4.25419 5.36128C4.36358 5.25309 4.51196 5.19231 4.66667 5.19231H5.83333C5.98804 5.19231 6.13642 5.25309 6.24581 5.36128C6.35521 5.46948 6.41667 5.61622 6.41667 5.76923C6.41667 5.92224 6.35521 6.06898 6.24581 6.17718C6.13642 6.28537 5.98804 6.34615 5.83333 6.34615H4.66667C4.51196 6.34615 4.36358 6.28537 4.25419 6.17718C4.14479 6.06898 4.08333 5.92224 4.08333 5.76923ZM4.66667 7.5C4.51196 7.5 4.36358 7.56078 4.25419 7.66898C4.14479 7.77717 4.08333 7.92391 4.08333 8.07692C4.08333 8.22993 4.14479 8.37667 4.25419 8.48487C4.36358 8.59306 4.51196 8.65385 4.66667 8.65385H5.83333C5.98804 8.65385 6.13642 8.59306 6.24581 8.48487C6.35521 8.37667 6.41667 8.22993 6.41667 8.07692C6.41667 7.92391 6.35521 7.77717 6.24581 7.66898C6.13642 7.56078 5.98804 7.5 5.83333 7.5H4.66667ZM7.58333 3.46154C7.58333 3.30853 7.64479 3.16179 7.75419 3.05359C7.86358 2.9454 8.01196 2.88462 8.16667 2.88462H9.33333C9.48804 2.88462 9.63642 2.9454 9.74581 3.05359C9.85521 3.16179 9.91667 3.30853 9.91667 3.46154C9.91667 3.61455 9.85521 3.76129 9.74581 3.86948C9.63642 3.97768 9.48804 4.03846 9.33333 4.03846H8.16667C8.01196 4.03846 7.86358 3.97768 7.75419 3.86948C7.64479 3.76129 7.58333 3.61455 7.58333 3.46154ZM8.16667 5.19231C8.01196 5.19231 7.86358 5.25309 7.75419 5.36128C7.64479 5.46948 7.58333 5.61622 7.58333 5.76923C7.58333 5.92224 7.64479 6.06898 7.75419 6.17718C7.86358 6.28537 8.01196 6.34615 8.16667 6.34615H9.33333C9.48804 6.34615 9.63642 6.28537 9.74581 6.17718C9.85521 6.06898 9.91667 5.92224 9.91667 5.76923C9.91667 5.61622 9.85521 5.46948 9.74581 5.36128C9.63642 5.25309 9.48804 5.19231 9.33333 5.19231H8.16667ZM7.58333 8.07692C7.58333 7.92391 7.64479 7.77717 7.75419 7.66898C7.86358 7.56078 8.01196 7.5 8.16667 7.5H9.33333C9.48804 7.5 9.63642 7.56078 9.74581 7.66898C9.85521 7.77717 9.91667 7.92391 9.91667 8.07692C9.91667 8.22993 9.85521 8.37667 9.74581 8.48487C9.63642 8.59306 9.48804 8.65385 9.33333 8.65385H8.16667C8.01196 8.65385 7.86358 8.59306 7.75419 8.48487C7.64479 8.37667 7.58333 8.22993 7.58333 8.07692ZM4.66667 13.2692V11.5385C4.66667 11.3855 4.72813 11.2387 4.83752 11.1305C4.94692 11.0223 5.09529 10.9615 5.25 10.9615H8.75C8.90471 10.9615 9.05308 11.0223 9.16248 11.1305C9.27188 11.2387 9.33333 11.3855 9.33333 11.5385V13.2692C9.33333 13.4222 9.27188 13.569 9.16248 13.6772C9.05308 13.7854 8.90471 13.8462 8.75 13.8462H5.25C5.09529 13.8462 4.94692 13.7854 4.83752 13.6772C4.72813 13.569 4.66667 13.4222 4.66667 13.2692Z"
      fill={fill}
    />
  </svg>
);

export const LinkIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 6H6C3.79086 6 2 7.79086 2 10C2 12.2091 3.79086 14 6 14H10M10 14H14C16.2091 14 18 12.2091 18 10C18 7.79086 16.2091 6 14 6H10"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MapPinIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <LineIcon className={className} color={fill} width="15" height="20">
    <path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </LineIcon>
);

export const MailIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <LineIcon className={className} color={fill} strokeWidth={2}>
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path d="m4 7 8 6 8-6" />
  </LineIcon>
);

export const PhoneIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3 5C3 3.89543 3.89543 3 5 3H7.27924C7.70967 3 8.09181 3.27543 8.22792 3.68377L9.72574 8.17721C9.88311 8.64932 9.66938 9.16531 9.23154 9.39815L7.5 10.25C8.5 12.25 9.75 13.5 11.75 14.5L12.6019 12.7685C12.8347 12.3306 13.3507 12.1169 13.8228 12.2743L18.3162 13.7721C18.7246 13.9082 19 14.2903 19 14.7208V17C19 18.1046 18.1046 19 17 19H15C8.37258 19 3 13.6274 3 7V5Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const KeyIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    className={className}
    viewBox="0 0 61 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M60 9.33917C60 8.49737 59.4915 7.54767 58.7914 7.08085L49.4845 0.876316C49.1205 0.633478 48.6543 0.5 48.1725 0.5C47.6902 0.5 47.2244 0.633375 46.8605 0.876316L37.5535 7.08085C37.3328 7.22783 37.1331 7.36245 36.9884 7.46119C36.8863 7.53087 36.7828 7.60147 36.6898 7.68228C36.2712 7.9816 36.2712 8.3841 36.2712 9.41255V9.45955H26.7042C25.7113 9.45955 24.8947 10.1717 24.8177 11.0735C24.8158 11.0735 24.8139 11.0735 24.8118 11.0735H6.46067C4.73699 11.0735 3.12123 11.7516 1.90972 12.9829C0.678112 14.1951 0 15.8109 0 17.5342C0 21.056 2.8651 23.9211 6.38687 23.9211H7.2936C7.54808 23.9211 7.78948 23.917 7.97326 23.9095C8.55613 23.8859 8.85576 23.6852 9.00594 23.4531C9.10252 23.3183 9.17312 23.1421 9.19394 22.9138C9.1993 22.8542 9.20466 22.7677 9.20878 22.6611C9.2161 22.4706 9.22012 22.2199 9.22012 21.9552V20.294H10.8813V22.0287C10.8813 23.0723 11.7303 23.921 12.7737 23.921H14.5084C14.773 23.921 15.0238 23.9169 15.2143 23.9094C15.3209 23.9052 15.4073 23.8999 15.4669 23.8945C15.7811 23.8659 15.9968 23.7428 16.1412 23.5882C16.2961 23.4438 16.4191 23.2277 16.4482 22.9136C16.4535 22.854 16.4589 22.7675 16.463 22.6609C16.4702 22.4704 16.4743 22.2197 16.4743 21.955V20.294H18.1356V22.0287C18.1356 23.0723 18.9846 23.921 20.028 23.921H24.8117C24.8189 23.921 24.8259 23.921 24.8325 23.9216C24.9675 24.7199 25.7412 25.3142 26.7041 25.3142H36.2711V25.6557C36.2711 26.4975 36.7796 27.4472 37.4797 27.914L46.7867 34.1186C47.1506 34.3613 47.6168 34.4948 48.0987 34.4948C48.5805 34.4948 49.0467 34.3613 49.4107 34.1186L58.7175 27.914C58.9383 27.7669 59.1379 27.6323 59.2827 27.5337C59.3855 27.4633 59.4893 27.3927 59.583 27.3117C59.9999 27.0095 59.9999 26.6063 59.9999 25.5823V9.33917H60ZM51.4599 10.2947V24.7717C51.4335 24.8268 51.2955 24.9915 50.9297 25.1726C50.309 25.4368 49.4864 25.5823 48.6102 25.5823C46.7541 25.5823 45.7025 24.9509 45.5998 24.7001V10.2232C45.6263 10.168 45.7641 10.0034 46.13 9.82226C46.7504 9.55799 47.5729 9.41255 48.4494 9.41255C50.3055 9.41266 51.3571 10.0441 51.4599 10.2947Z"
      fill={fill}
      stroke={fill}
    />
  </svg>
);

export const LockIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <LineIcon className={className} color={fill} width="12" height="15">
    <rect x="5" y="10.5" width="14" height="10" rx="2.4" />
    <path d="M8.5 10.5V7.5a3.5 3.5 0 0 1 7 0v3" />
  </LineIcon>
);

export const GlobeIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <LineIcon className={className} color={fill} width="17" height="17">
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 3 2.5 15 0 18M12 3c-2.5 3-2.5 15 0 18" />
  </LineIcon>
);

export const CreditCardIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2 8H18M2 12H6M4 4H16C17.1046 4 18 4.89543 18 6V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6C2 4.89543 2.89543 4 4 4Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeIcon = ({
  className = "",
  fill = "#6B7280",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 5C5 5 2 10 2 10C2 10 5 15 10 15C15 15 18 10 18 10C18 10 15 5 10 5Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="10"
      cy="10"
      r="2"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeOffIcon = ({
  className = "",
  fill = "#6B7280",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3 3L17 17M10.5 7.5C11.3284 7.5 12 8.17157 12 9C12 9.82843 11.3284 10.5 10.5 10.5C9.67157 10.5 9 9.82843 9 9M7.36154 5.36154C8.15385 5.13077 8.96923 5 9.80769 5C14 5 17 10 17 10C17 10 16.2308 11.3846 14.9231 12.6923M5.07692 6.07692C3.53846 7.23077 2.61538 9.23077 2.61538 9.23077C2.61538 9.23077 5.07692 15 9.80769 15C11.0769 15 12.2308 14.7692 13.2308 14.3846"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReplyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="85"
    height="85"
    style={{
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)",
      contentVisibility: "visible",
    }}
  >
    <defs>
      <clipPath id="__lottie_element_94">
        <rect width="30" height="30" x="0" y="0"></rect>
      </clipPath>
    </defs>
    <g clipPath="url(#__lottie_element_94)">
      <circle cx="15" cy="15" r="15" fill="transparent" />

      <g transform="matrix(1,0,0,1,3,14)">
        <g transform="matrix(1,0,0,1,0,0)">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            fillOpacity="0"
            stroke="white"
            strokeWidth="2"
            d="M1,1 C1,1 15,1 15,1"
          />
        </g>
      </g>

      <g transform="matrix(1,0,0,1,9,6)">
        <g transform="matrix(1,0,0,1,7,9)">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            fillOpacity="0"
            stroke="white"
            strokeWidth="2"
            d="M-2,-4 C-2,-4 2,0 2,0 C2,0 -2,4 -2,4"
          />
        </g>
      </g>

      <g transform="matrix(1,0,0,1,0.21,-1)">
        <g transform="matrix(1,0,0,1,15.395,16)">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            fillOpacity="0"
            stroke="white"
            strokeWidth="2"
            d="M-10.395,5 C-8.573,8.559 -4.878,11 -0.605,11 C5.47,11 10.395,6.074 10.395,0 C10.395,-6.075 5.47,-11 -0.605,-11 C-4.878,-11 -8.573,-8.56 -10.395,-5"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ReplyIcon;

export const DocumentIcon = ({
  backgroundColor = "#000000",
}: {
  backgroundColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="30"
    height="30"
    className="w-[85px] h-[85px] text-white"
    fill="none"
  >
    {/* Chat box with lines */}
    <g transform="translate(4.75,1.75)">
      <g transform="translate(10.25,13.25)">
        <path
          d="M9.707,-6.207C9.707,-6.207 3.207,-12.707 3.207,-12.707C3.019,-12.895 2.765,-13 2.5,-13C2.5,-13 -8,-13 -8,-13C-9.105,-13 -10,-12.105 -10,-11C-10,-11 -10,-2.031 -10,-2.031C-10,-2.031 -10,11 -10,11C-10,11 -10,11.031 -10,11.031C-10,12.118 -9.119,13 -8.031,13C-8.031,13 -8,13 -8,13C-8,13 1.721,13 1.721,13C1.721,13 8.031,13 8.031,13C9.118,13 10,12.118 10,11.031C10,11.031 10,-0.413 10,-0.413C10,-0.413 10,-2.031 10,-2.031C10,-2.031 10,-5.5 10,-5.5C10,-5.765 9.895,-6.02 9.707,-6.207Z
            M5,8C5,8 -5,8 -5,8C-5.552,8 -6,7.553 -6,7C-6,6.447 -5.552,6 -5,6C-5,6 5,6 5,6C5.553,6 6,6.447 6,7C6,7.553 5.553,8 5,8Z
            M5,4C5,4 -5,4 -5,4C-5.552,4 -6,3.553 -6,3C-6,2.447 -5.552,2 -5,2C-5,2 5,2 5,2C5.553,2 6,2.447 6,3C6,3.553 5.553,4 5,4Z
            M5,0C5,0 -5,0 -5,0C-5.552,0 -6,-0.448 -6,-1C-6,-1.552 -5.552,-2 -5,-2C-5,-2 5,-2 5,-2C5.553,-2 6,-1.552 6,-1C6,-0.448 5.553,0 5,0Z
            M3,-5C2.448,-5 2,-5.448 2,-6C2,-6 2,-11.096 2,-11.096C2,-11.096 8.096,-5 8.096,-5C8.096,-5 3,-5 3,-5Z"
          fill="currentColor"
        />
      </g>
    </g>
    <g transform="translate(12.939,13.627)">
      <g transform="translate(8.25,8.25)">
        <path
          d="M8,0C8,4.418-4.418,8,0,8C-4.418,8-8,4.418-8,0C-8,-4.418-4.418,-8,0,-8C4.418,-8,8,-4.418,8,0Z"
          fill={backgroundColor}
        />
      </g>
    </g>
    {/* Search bubble */}
    <g transform="translate(11.189,11.877)">
      <g transform="translate(10,10)">
        <path
          d="M0,-5C-2.762,-5 -5,-2.762 -5,0C-5,2.762 -2.762,5 0,5C2.762,5 5,2.762 5,0C5,-2.762 2.762,-5 0,-5Z"
          stroke="currentColor"
          strokeWidth="2"
          fill={backgroundColor}
        />
      </g>
      <g transform="translate(15.412,15.412)">
        <path
          d="M1.588,1.588C1.588,1.588 -1.588,-1.588 -1.588,-1.588"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          fill={backgroundColor}
        />
      </g>
      {/* Main rounded shape */}
    </g>
  </svg>
);

export const FirstFunnelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="30"
    height="30"
    className="w-[85px] h-[85px] text-white"
    fill="currentColor"
  >
    <path d="M 13.5 2 C 13.224 2 13 2.224 13 2.5 L 13 4 L 13 4.5 C 13 4.776 12.776 5 12.5 5 C 12.224 5 12 4.776 12 4.5 L 12 3.6835938 C 12 3.6835938 9 5.227 9 9 A 1.0001 1.0001 0 1 0 9 11 C 8.9999998 11.000662 9 11.001292 9 11.001953 C 9 12.105953 9.5273437 13.214844 9.5273438 13.214844 C 9.3153438 13.336844 8.9666875 13.724109 9.0546875 14.412109 C 9.2186875 15.695109 9.7749062 16.021828 10.128906 16.048828 C 10.263906 17.245828 11.55 18.777 12 19 L 12 21 C 11.99791 21.006269 11.994338 21.011353 11.992188 21.017578 C 11.660701 21.058075 11.364785 21.253188 11.214844 21.556641 L 10.898438 22.195312 C 8.7627088 23.392506 4.4203215 23.309241 3.2871094 27 L 13.914062 27 L 14.5 25.083984 L 13.361328 23 L 14.974609 23 L 16.638672 23 L 15.5 25.083984 L 16.085938 27 L 26.712891 27 C 25.579679 23.309241 21.237291 23.392506 19.101562 22.195312 L 18.785156 21.556641 C 18.635215 21.253188 18.339299 21.058075 18.007812 21.017578 C 18.005662 21.011353 18.00209 21.006269 18 21 L 18 19 C 18.45 18.777 19.736094 17.245828 19.871094 16.048828 C 20.225094 16.021828 20.781313 15.695109 20.945312 14.412109 C 21.033313 13.723109 20.684656 13.336844 20.472656 13.214844 C 20.472656 13.214844 21 12.212953 21 11.001953 C 21 11.001284 21 11.000669 21 11 A 1.0001 1.0001 0 1 0 21 9 L 14 9 C 13.448 9 13 8.552 13 8 C 13 7.448 13.448 7 14 7 L 20.919922 7 C 20.133922 4.561 18 3.6777344 18 3.6777344 L 18 4.5 C 18 4.776 17.776 5 17.5 5 C 17.224 5 17 4.776 17 4.5 L 17 3.2949219 L 17 2.5 C 17 2.224 16.776 2 16.5 2 L 13.5 2 z" />
  </svg>
);

export const SecondFunnelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="30"
    height="30"
    className="w-[85px] h-[85px] text-white"
    fill="currentColor"
  >
    <path d="M 5.7792969 0 C 5.5242969 0 5.30925 0.1923125 5.28125 0.4453125 L 5.2714844 0.54492188 C 5.2384844 0.84792187 5.0235156 1.1046406 4.7285156 1.1816406 C 4.2455156 1.3076406 3.7929062 1.5018125 3.3789062 1.7578125 C 3.1939062 1.8728125 2.9590625 1.8684219 2.7890625 1.7324219 L 2.5800781 1.5644531 C 2.3810781 1.4054531 2.0940625 1.4215625 1.9140625 1.6015625 L 1.6015625 1.9140625 C 1.4215625 2.0940625 1.4054531 2.3810781 1.5644531 2.5800781 L 1.7324219 2.7890625 C 1.8684219 2.9590625 1.8728125 3.1929063 1.7578125 3.3789062 C 1.5018125 3.7929063 1.3056875 4.2455156 1.1796875 4.7285156 C 1.1026875 5.0235156 0.84696875 5.2384844 0.54296875 5.2714844 L 0.44335938 5.28125 C 0.19135937 5.30925 3.7007434e-17 5.5242969 0 5.7792969 L 0 6.2207031 C 0 6.4757031 0.1923125 6.69075 0.4453125 6.71875 L 0.54492188 6.7285156 C 0.84792187 6.7625156 1.1046406 6.9764844 1.1816406 7.2714844 C 1.3076406 7.7544844 1.5018125 8.2070937 1.7578125 8.6210938 C 1.8728125 8.8060938 1.8684219 9.0409375 1.7324219 9.2109375 L 1.5644531 9.4199219 C 1.4054531 9.6189219 1.4205625 9.9059375 1.6015625 10.085938 L 1.9121094 10.398438 C 2.0921094 10.578437 2.379125 10.594547 2.578125 10.435547 L 2.7871094 10.267578 C 2.9571094 10.131578 3.1929063 10.127188 3.3789062 10.242188 C 3.7929063 10.498188 4.2455156 10.692359 4.7285156 10.818359 C 5.0235156 10.895359 5.2365313 11.151078 5.2695312 11.455078 L 5.28125 11.554688 C 5.31025 11.807687 5.5242969 12 5.7792969 12 L 6.2207031 12 C 6.4757031 12 6.69075 11.807688 6.71875 11.554688 L 6.7285156 11.455078 C 6.7615156 11.152078 6.9764844 10.895359 7.2714844 10.818359 C 7.7544844 10.692359 8.2070937 10.498187 8.6210938 10.242188 C 8.8060938 10.127187 9.0409375 10.131578 9.2109375 10.267578 L 9.4199219 10.435547 C 9.6189219 10.594547 9.9059375 10.579437 10.085938 10.398438 L 10.398438 10.085938 C 10.578437 9.9059375 10.594547 9.6189219 10.435547 9.4199219 L 10.267578 9.2109375 C 10.131578 9.0409375 10.127188 8.8070937 10.242188 8.6210938 C 10.498188 8.2070938 10.692359 7.7544844 10.818359 7.2714844 C 10.895359 6.9764844 11.151078 6.7615156 11.455078 6.7285156 L 11.554688 6.71875 C 11.807687 6.69075 12 6.4757031 12 6.2207031 L 12 5.7792969 C 12 5.5242969 11.807688 5.30925 11.554688 5.28125 L 11.455078 5.2714844 C 11.152078 5.2384844 10.895359 5.0235156 10.818359 4.7285156 C 10.692359 4.2455156 10.498187 3.7929062 10.242188 3.3789062 C 10.127187 3.1939062 10.131578 2.9590625 10.267578 2.7890625 L 10.435547 2.5800781 C 10.594547 2.3810781 10.579437 2.0940625 10.398438 1.9140625 L 10.085938 1.6015625 C 9.9059375 1.4215625 9.6189219 1.4054531 9.4199219 1.5644531 L 9.2109375 1.7324219 C 9.0409375 1.8684219 8.8070938 1.8728125 8.6210938 1.7578125 C 8.2070938 1.5018125 7.7544844 1.3056875 7.2714844 1.1796875 C 6.9764844 1.1036875 6.7615156 0.84792188 6.7285156 0.54492188 L 6.71875 0.4453125 C 6.69075 0.1923125 6.4757031 -3.7007434e-17 6.2207031 0 L 5.7792969 0 z M 14.28125 2.0039062 C 13.83525 1.9929063 13.394984 2.0195 12.958984 2.0625 C 13.618984 3.2255 14 4.567 14 6 C 14 10.419 10.419 14 6 14 C 4.95 14 3.94925 13.792781 3.03125 13.425781 C 3.15125 16.540781 4.546375 19.325953 6.734375 21.251953 C 7.564375 21.981953 8 23.061969 8 24.167969 L 8 28 L 18 28 L 18 26.441406 C 18 25.580406 18.550187 24.816922 19.367188 24.544922 L 22.632812 23.457031 C 23.448813 23.184031 24 22.419594 24 21.558594 L 24 17.744141 L 26.267578 16.962891 A 1 1 0 0 0 27 16 A 1 1 0 0 0 26.773438 15.369141 L 26.746094 15.335938 A 1 1 0 0 0 26.716797 15.302734 L 23.958984 11.998047 C 23.5582 6.4851023 19.861766 2.1444805 14.28125 2.0039062 z M 6 4 C 7.105 4 8 4.895 8 6 C 8 7.105 7.105 8 6 8 C 4.895 8 4 7.105 4 6 C 4 4.895 4.895 4 6 4 z" />
  </svg>
);

export const ThirdFunnelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="30"
    height="30"
    className="w-[85px] h-[85px] text-white"
    fill="currentColor"
  >
    <path d="M 9 4 C 5.6983746 4 3 6.6983746 3 10 L 3 15 C 3 18.166667 3.8017848 20.36235 4.6425781 21.763672 C 4.9441565 22.266302 5.2484796 22.642187 5.53125 22.958984 L 5.1992188 23.400391 C 5.0692188 23.573391 5 23.784 5 24 L 5 25 C 5 25.552 5.447 26 6 26 L 26 26 C 26.553 26 27 25.552 27 25 L 27 24 C 27 23.784 26.930781 23.573391 26.800781 23.400391 L 24 19.666016 L 24 10 A 1.0001 1.0001 0 0 0 22.984375 8.9863281 A 1.0001 1.0001 0 0 0 22 10 L 20 10 L 20 12 L 22 12 L 22 19 L 10 19 L 10 12 L 12 12 L 12 10 L 10 10 A 1.0001 1.0001 0 0 0 8.984375 8.9863281 A 1.0001 1.0001 0 0 0 8 10 L 8 19.666016 L 6.7558594 21.326172 C 6.6297595 21.156734 6.4987722 20.971912 6.3574219 20.736328 C 5.6982152 19.63765 5 17.833333 5 15 L 5 10 C 5 7.7796254 6.7796254 6 9 6 L 13.978516 6 C 14.547041 6 14.984648 6.4429788 14.978516 7.0117188 L 14.966797 8.0058594 C 14.431009 8.0243474 14 8.4597331 14 9 L 14 14 C 14 14.552 14.448 15 15 15 L 15 16 C 15 16.552 15.448 17 16 17 C 16.552 17 17 16.552 17 16 L 17 15 C 17.552 15 18 14.552 18 14 L 18 9 C 18 8.448 17.552 8 17 8 L 16.966797 8 L 16.978516 7.0332031 C 16.996388 5.3759436 15.63599 4 13.978516 4 L 9 4 z" />
  </svg>
);

export const XIcon = () => (
  <LineIcon
    className="w-[85px] h-[85px] text-white"
    width="30"
    height="30"
    strokeWidth={2.2}
  >
    <path d="M6 6l12 12M18 6 6 18" />
  </LineIcon>
);

export const CheckIcon = () => (
  <LineIcon
    className="w-[85px] h-[85px] text-white"
    width="30"
    height="30"
    strokeWidth={2.4}
  >
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </LineIcon>
);

export const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="30"
    height="30"
    className="w-[85px] h-[85px] text-white"
    fill="currentColor"
  >
    <path d="M 14 3 C 13.448 3 13 3.448 13 4 L 13 11.535156 L 6.4726562 7.7675781 C 5.9946562 7.4915781 5.3834219 7.6567656 5.1074219 8.1347656 L 4.1074219 9.8652344 C 3.8314219 10.343234 3.9946563 10.956422 4.4726562 11.232422 L 10.998047 15 L 4.4726562 18.767578 C 3.9946563 19.043578 3.8314219 19.656766 4.1074219 20.134766 L 5.1074219 21.865234 C 5.3834219 22.343234 5.9946563 22.508422 6.4726562 22.232422 L 13 18.464844 L 13 26 C 13 26.552 13.448 27 14 27 L 16 27 C 16.552 27 17 26.552 17 26 L 17 18.464844 L 23.525391 22.232422 C 24.003391 22.508422 24.616578 22.343234 24.892578 21.865234 L 25.892578 20.134766 C 26.168578 19.656766 26.004391 19.043578 25.525391 18.767578 L 19 15 L 25.525391 11.232422 C 26.003391 10.956422 26.168578 10.343234 25.892578 9.8652344 L 24.892578 8.1347656 C 24.616578 7.6567656 24.004391 7.4915781 23.525391 7.7675781 L 17 11.535156 L 17 4 C 17 3.448 16.552 3 16 3 L 14 3 z" />
  </svg>
);

export const NumberIcon = ({ number = 1 }: { number?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="30"
    height="30"
    className="w-[85px] h-[85px] text-white"
    fill="currentColor"
  >
    <circle cx="15" cy="15" r="12" />
    <text
      x="15"
      y="19"
      textAnchor="middle"
      fontSize="12"
      fontWeight="bold"
      fill="#384999"
    >
      {number}
    </text>
  </svg>
);

export const InstagramIcon = () => (
  // The padded viewBox keeps the glyph at its old size inside the 52px box.
  <LineIcon viewBox="-8 -8 40 40" width="52" height="52" color="#F6F5F7">
    <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r=".8" fill="#F6F5F7" />
  </LineIcon>
);

export const LinkedInIcon = () => (
  // Same padded viewBox as InstagramIcon, so the two sit at one size.
  <LineIcon viewBox="-8 -8 40 40" width="52" height="52" color="#F6F5F7">
    <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
    <path d="M8 11v5.5M12 16.5V11M12 13.5a2.2 2.2 0 0 1 4.4 0v3" />
    <circle cx="8" cy="7.6" r=".8" fill="#F6F5F7" />
  </LineIcon>
);

export const FacebookIconOutline = () => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5834 23.6667V28.3333H23.0834V36.5H27.75V28.3333H31.25L32.4167 23.6667H27.75V21.3333C27.75 20.6979 28.2813 20.1667 28.9167 20.1667H32.4167V15.5H28.9167C25.7395 15.5 23.0834 18.1561 23.0834 21.3333V23.6667H19.5834Z"
      stroke="#F6F5F7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/** The heyFinn logo: Finn as the mark, then the write-on wordmark. */
export const LogoIcon = ({
  color,
  animate = false,
}: {
  color: string;
  animate?: boolean;
}) => (
  <span className="flex h-full items-center gap-[7px]" style={{ color }}>
    <Finn mark className="h-auto w-[30px]" />
    <Wordmark
      animate={animate}
      className="relative top-[2px] h-[20px] w-auto"
    />
  </span>
);

export const LightingBoltIcon = ({ color }: { color: string }) => (
  <LineIcon className="w-6 h-6 sm:w-8 sm:h-8" color={color}>
    <path d="M13 3L5 13.5h6L10 21l8-10.5h-6z" />
  </LineIcon>
);
export const URLChainIcon = ({
  color,
  className,
}: {
  color: string;
  className?: string;
}) => (
  <LineIcon className={`w-[26px] h-[26px] ${className}`} color={color}>
    <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
    <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
  </LineIcon>
);
export const BriefcaseIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26 21.7407C25.7207 23.2324 24.5591 24.3623 23.0356 24.5274H3.06592C1.49805 24.3877 0.241211 23.1817 0.0507812 21.6138V9.30568C0.19043 7.56642 2.0249 5.77638 3.77686 5.77638H7.80762V3.11671C7.80762 3.04689 8.01074 2.56447 8.06787 2.46925C8.4043 1.89161 9.04541 1.56788 9.70557 1.5171C11.9145 1.36476 14.3076 1.62501 16.5356 1.53614C17.1006 1.60597 17.6973 1.97413 17.9829 2.46925C18.2686 2.96437 18.2432 3.04689 18.2432 3.11671V5.77638H22.2739C24.0068 5.77638 25.8096 7.53468 26 9.22316V21.7407ZM16.6753 5.77638V3.31984C16.6753 3.30079 16.4277 3.04689 16.3516 3.09132L9.58496 3.12306C9.54688 3.16114 9.38184 3.31349 9.38184 3.32618V5.78273H16.6816L16.6753 5.77638ZM15.9136 14.7964L23.1816 13.0191C24.521 12.5938 24.5337 11.3623 24.4766 10.1563C24.4067 8.60109 23.7466 7.56007 22.1216 7.34425H3.87842C2.31055 7.57911 1.65039 8.59474 1.56787 10.1055C1.48535 11.6162 1.51709 12.6065 2.90723 13.0318L10.1372 14.7964C10.1943 13.9839 10.8481 13.1651 11.686 13.0698C12.2637 13.0064 13.8506 13 14.4219 13.0698C15.228 13.1777 15.8691 14.0029 15.9199 14.7901L15.9136 14.7964ZM24.4258 14.1934L23.5752 14.5361L15.958 16.4024C15.8628 16.7388 15.9326 17.0943 15.8438 17.4561C15.6787 18.1162 15.0503 18.7383 14.3647 18.8145C13.73 18.8843 12.4224 18.8652 11.7749 18.8145C10.8228 18.7383 10.2261 17.9702 10.1309 17.0625C10.0356 16.1548 10.1816 16.4785 10.0801 16.4024L2.46289 14.5361L1.6123 14.1934L1.56152 14.5234C1.66309 16.6563 1.43457 18.897 1.56152 21.0171C1.68848 23.1372 2.0376 22.7817 3.11035 22.9658H22.8262C23.6133 22.9277 24.2671 22.3311 24.4131 21.5693C24.394 19.2905 24.6226 16.7896 24.4702 14.5298C24.4639 14.4155 24.4258 14.314 24.4194 14.1997L24.4258 14.1934ZM11.8447 14.6567C11.7432 14.6885 11.7178 14.8345 11.7114 14.9234C11.6606 15.3359 11.6543 16.5991 11.7114 17.0054C11.7686 17.4116 11.8003 17.2212 11.9653 17.2593C12.27 17.3291 13.6221 17.3228 13.9712 17.2783C14.1743 17.2529 14.3267 17.2212 14.3521 16.999C14.4092 16.561 14.3901 15.4248 14.3521 14.9678C14.3457 14.8789 14.3394 14.7583 14.2759 14.6885C14.1489 14.5615 12.1812 14.6758 11.8511 14.6504L11.8447 14.6567Z"
      fill="#F6F5F7"
    />
  </svg>
);

export const LocationIcon = () => (
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 9.18182C17 15.5455 9 21 9 21C9 21 1 15.5455 1 9.18182C1 7.01186 1.84285 4.93079 3.34315 3.3964C4.84344 1.86201 6.87827 1 9 1C11.1217 1 13.1566 1.86201 14.6569 3.3964C16.1571 4.93079 17 7.01186 17 9.18182Z"
      fill="white"
    />
    <path
      d="M9 11.9091C10.4728 11.9091 11.6667 10.688 11.6667 9.18182C11.6667 7.67559 10.4728 6.45455 9 6.45455C7.52724 6.45455 6.33333 7.67559 6.33333 9.18182C6.33333 10.688 7.52724 11.9091 9 11.9091Z"
      fill="white"
    />
    <path
      d="M17 9.18182C17 15.5455 9 21 9 21C9 21 1 15.5455 1 9.18182C1 7.01186 1.84285 4.93079 3.34315 3.3964C4.84344 1.86201 6.87827 1 9 1C11.1217 1 13.1566 1.86201 14.6569 3.3964C16.1571 4.93079 17 7.01186 17 9.18182Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11.9091C10.4728 11.9091 11.6667 10.688 11.6667 9.18182C11.6667 7.67559 10.4728 6.45455 9 6.45455C7.52724 6.45455 6.33333 7.67559 6.33333 9.18182C6.33333 10.688 7.52724 11.9091 9 11.9091Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CameraIcon = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 44 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_269_18487)">
      <rect
        width="44"
        height="44"
        transform="translate(0 0.0878906)"
        fill="#EAF1FF"
      />
      <path
        d="M44.0002 35.2539C43.4538 37.4526 41.7235 39.1829 39.4077 39.3651H4.76192C2.39409 39.1569 0.286459 37.2965 0.0913086 34.8636V12.9937C0.45559 10.717 2.21195 8.92157 4.51473 8.66137H11.8394C11.9435 6.81394 13.0884 5.22672 14.9098 4.8234C19.2551 4.87544 24.1209 4.38106 28.4402 4.71932C30.5739 4.88845 32.1871 6.48869 32.1741 8.66137H39.5898C41.3332 8.86953 42.8163 9.96237 43.5969 11.5236L44.0132 12.7856V35.2539H44.0002ZM3.12265 11.6927C2.64128 12.1741 2.36807 12.9026 2.31603 13.5922C2.4071 20.7737 2.1469 28.0073 2.44613 35.1759C2.74536 36.2036 3.69509 36.9712 4.76192 37.0623H39.3296C40.7477 36.9192 41.7365 35.7743 41.7755 34.3562V13.332C41.5413 11.6797 40.3834 10.9902 38.8222 10.8861C36.1682 10.717 33.358 11.0422 30.691 10.8731C29.6632 10.4177 30.0144 9.58508 29.9364 8.71341C29.8583 7.84174 29.481 7.1522 28.5053 6.97006L15.8335 6.94404C15.0529 6.98307 14.3633 7.47745 14.2593 8.28408C14.1552 9.0907 14.6105 10.3657 13.4787 10.8471C10.7726 11.0682 7.88433 10.6909 5.20426 10.8861C4.43667 10.9381 3.68208 11.1333 3.13566 11.6927H3.12265Z"
        fill="black"
      />
      <path
        d="M20.9982 13.7483C29.3117 13.0068 35.1271 21.7365 31.016 29.0742C26.6576 36.8412 14.9616 35.6703 12.2555 27.1617C10.2779 20.9689 14.5062 14.3208 21.0112 13.7353L20.9982 13.7483ZM21.7658 16.0641C13.9208 16.3243 11.1626 26.7714 17.8498 30.8305C23.4571 34.2261 30.5476 29.9198 30.0142 23.3758C29.6759 19.1605 25.9681 15.934 21.7658 16.0641Z"
        fill="black"
      />
      <path
        d="M38.3928 14.2689C40.2663 16.1423 37.4171 19.1347 35.4656 17.2482C33.449 15.2967 36.4543 12.3304 38.3928 14.2689Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_269_18487">
        <rect
          width="44"
          height="44"
          fill="white"
          transform="translate(0 0.0878906)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SmallPhoneIcon = ({ color = "#111111" }: { color?: string }) => (
  <svg
    className="w-full h-full"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_269_18527)">
      <path
        d="M21.6104 0C22.9281 0.401042 24.051 1.18021 24.5437 2.50938C25.0364 3.83854 24.8989 4.76667 24.7844 5.52292C24.6698 6.27917 23.4552 6.35938 23.3292 5.17917C23.226 4.14792 23.5583 3.56354 22.9396 2.56667C22.3667 1.65 21.4844 1.42083 20.4646 1.35208C15.3312 1.03125 9.85415 1.60417 4.67498 1.35208C2.92186 1.48958 2.01665 2.38333 1.87915 4.13646V39.8177C2.02811 41.5365 2.97915 42.3844 4.67498 42.5219C9.85415 42.2583 15.4 42.8771 20.5448 42.5219C21.9542 42.4188 22.9625 41.8458 23.3177 40.4135V27.9813C23.3406 27.1219 24.2344 26.8354 24.7385 27.5115L24.7844 40.3333C24.5896 42.1437 23.2489 43.5417 21.4729 43.8854H4.06769C2.2229 43.725 0.744775 42.2583 0.50415 40.425V3.39167C0.77915 1.65 2.03957 0.458333 3.68957 0H21.6104Z"
        fill={color}
      />
      <path
        d="M31.0521 11.7561C36.0364 11.2176 37.4344 18.1843 32.5989 19.4791L33.8021 25.6093C33.9052 26.3655 33.2979 27.0645 32.5417 27.0759C31.9344 27.0874 30.4677 26.1249 29.8031 25.8384C25.9531 24.1197 21.6448 23.6843 17.4739 24.2916C16.7521 24.3947 15.5031 24.7957 14.8844 24.7957C14.2656 24.7957 13.7614 24.303 13.5781 23.6957C12.776 20.9228 12.6042 17.6228 11.8479 14.7926C11.9396 13.2572 13.475 13.452 14.5979 13.1884C19.3417 12.0884 23.2031 10.0947 26.5489 6.53114C29.8948 2.9676 27.6031 5.04156 28.1187 4.83531C28.8635 4.53739 29.6198 4.83531 29.8948 5.5801C30.2729 7.6426 30.7656 9.68218 31.0521 11.7561ZM32.2437 25.3916L28.5083 6.43948C24.8073 11.0572 19.2271 14.0364 13.3719 14.8384L15.0448 23.3176C19.9146 22.0572 25.2771 22.3895 29.9292 24.3145C30.7198 24.6468 31.4531 25.0707 32.2437 25.3801V25.3916ZM32.3354 18.0926C35.2229 17.1301 34.4667 12.9593 31.3958 13.1999L32.3354 18.0926Z"
        fill={color}
      />
      <path
        d="M6.63436 16.7521C6.26769 17.1188 6.23332 17.6344 6.26769 18.1271C6.38228 19.3188 6.88644 21.8282 7.23019 22.9969C7.57394 24.1657 7.82603 24.1657 8.53644 24.1886C9.24686 24.2115 10.6677 23.6042 11.3437 23.6844C12.0198 23.7646 12.1114 24.3032 11.9052 24.7157C11.6989 25.1282 10.8625 25.1511 10.3812 25.3344L12.4437 35.5438C12.9594 36.1282 13.8989 35.8532 13.8302 35.0282L12.3864 27.3282C12.5927 26.5948 13.4292 26.4688 13.8073 27.1563L15.2739 34.6042C15.7437 37.274 12.2146 38.4084 11.0687 35.9792C10.2667 32.5761 9.69374 29.1157 9.00624 25.6896C8.93749 25.4719 8.70832 25.6553 8.47915 25.6209C7.18436 25.4719 6.23332 24.7615 5.87811 23.5011C5.51144 22.2292 4.96144 19.5021 4.8354 18.1959C4.68644 16.5917 5.46561 15.4115 7.00103 14.9761C7.50519 14.8386 9.13228 14.4605 9.59061 14.4719C10.3125 14.4834 10.6219 15.4917 9.86561 15.8699C9.10936 16.248 7.29894 16.099 6.65728 16.7407L6.63436 16.7521Z"
        fill={color}
      />
      <path
        d="M8.12406 3.27731L16.947 3.25439C17.8636 3.35752 17.8751 4.59502 16.6834 4.7096C14.1511 4.96169 11.2064 4.52627 8.62823 4.7096C7.73448 4.7096 7.32198 3.78148 8.13552 3.26585L8.12406 3.27731Z"
        fill={color}
      />
      <path
        d="M35.7386 20.6138C35.9678 20.6138 36.1855 20.7742 36.3574 20.9002C36.8844 21.244 39.5657 23.3752 39.8407 23.7648C40.3907 24.5325 39.5542 25.2888 38.8209 24.7846L35.2001 21.8054C34.799 21.3471 35.1428 20.6596 35.7271 20.6252L35.7386 20.6138Z"
        fill={color}
      />
      <path
        d="M35.7959 10.4957L39.6459 7.69985C40.4251 7.37902 41.0782 8.27277 40.4824 8.88006L36.6553 11.653C35.8646 12.0655 35.2115 11.1259 35.7959 10.4957Z"
        fill={color}
      />
      <path
        d="M42.6136 12.799C43.8168 12.7073 43.9084 13.899 43.0605 14.1854C41.7199 14.6438 39.8636 14.6552 38.4657 15.0906C37.6293 15.1135 37.3543 14.0135 38.1678 13.6698C39.6001 13.4865 41.1928 12.9021 42.6136 12.799Z"
        fill={color}
      />
      <path
        d="M33.848 9.4071C33.298 9.91127 32.4157 9.37273 32.622 8.66231L34.948 4.46856C35.4522 3.8269 36.4605 4.33106 36.2084 5.13315L33.8365 9.4071H33.848Z"
        fill={color}
      />
      <path
        d="M37.549 17.5085C37.6636 17.4856 37.7438 17.5085 37.8469 17.5085C38.5115 17.5773 41.7771 18.3908 42.3729 18.6429C42.9688 18.895 42.8886 20.0981 42.0865 20.0523L37.4802 18.895C36.7698 18.6544 36.85 17.6346 37.549 17.4971V17.5085Z"
        fill={color}
      />
      <path
        d="M11.3781 39.646C11.6417 39.5887 13.6927 39.5772 13.9104 39.646C14.5406 39.8293 14.575 40.9179 13.7386 41.0668C12.9021 41.2158 11.8594 41.1356 11.4813 41.0554C10.725 40.872 10.6792 39.8064 11.3781 39.6575V39.646Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_269_18527">
        <rect width="44" height="44" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ThumbsUpIcon = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 44 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43.0005 27.8408C43.0004 29.2571 42.6558 30.376 42.2251 31.5566C41.7938 32.7391 41.2775 33.9839 40.8003 35.8086L40.7964 35.8213C40.1306 38.2298 38.4477 40.2408 36.1333 41.0781C34.983 41.4942 33.4619 41.6207 32.0669 41.6465C30.6484 41.6727 29.2352 41.5945 28.2573 41.5439C24.3211 41.4372 19.678 40.6054 16.0093 39.1309V39.1299C15.7974 39.053 15.3635 38.8778 14.9829 38.7109C14.7739 38.6193 14.5587 38.5212 14.3892 38.4346C14.3083 38.3932 14.2124 38.3414 14.1274 38.2861C14.0888 38.261 14.0179 38.2133 13.9458 38.1465C13.9104 38.1137 13.8463 38.051 13.7847 37.96C13.733 37.8836 13.6089 37.6795 13.6089 37.3877V15.5977L14.0181 15.2979C15.1717 14.4533 16.4172 13.4307 17.4614 12.2676C18.5067 11.1033 19.3058 9.84606 19.647 8.53418C19.7653 8.04226 19.7978 7.38876 19.8247 6.57324C19.8501 5.80548 19.8715 4.90345 20.0161 4.0918C20.1591 3.28965 20.4508 2.39062 21.1567 1.75684C21.9053 1.08489 22.9194 0.88212 24.1187 1.06348H24.1206C25.7652 1.31528 27.1331 2.30999 28.0972 3.55176C29.0606 4.79284 29.68 6.35248 29.7944 7.88184L29.8247 8.39258C29.9157 10.4793 29.5939 12.7019 29.0034 14.6982H35.5962C37.4174 14.6984 39.1763 15.5115 40.5073 16.7295C41.8399 17.949 42.8208 19.6442 42.9956 21.5107L43.0005 21.5576V27.8408Z"
      stroke="#111111"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M4.87258 16.8424C6.26474 16.8424 7.15971 16.8424 7.35859 16.9404C7.65691 16.9404 7.85579 17.2342 8.05467 17.528V37.1144C8.05467 37.5061 7.65691 37.7999 7.25915 37.7999C6.86139 37.7999 6.06586 37.7999 5.1709 37.7999C4.27594 37.7999 3.38097 37.7999 2.88377 37.7999C2.48601 37.7999 2.18769 37.5061 1.98881 37.1144V17.6259C2.08825 17.2342 2.48601 16.9404 2.88377 16.9404C3.18209 16.9404 3.87817 16.9404 4.87258 16.9404M4.87258 14.8838C3.97761 14.8838 3.08265 14.8838 2.68489 14.8838C1.39217 15.0797 0.298321 16.059 0 17.3321V37.3102C0.298321 38.5833 1.39217 39.5627 2.68489 39.6606C3.28153 39.6606 4.1765 39.6606 5.1709 39.6606C6.1653 39.6606 7.06027 39.6606 7.55747 39.5627C8.85019 39.3668 9.8446 38.2895 10.0435 37.1144V17.3321C9.8446 16.2548 8.94963 15.3734 7.95523 15.0797C7.45803 14.9817 6.1653 14.8838 4.97202 14.8838H4.87258Z"
      fill="#111111"
    />
  </svg>
);

export const GearIcon = ({ color = "black" }: { color?: string }) => (
  <svg
    className="w-full h-full"
    viewBox="0 0 44 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.6058 0C33.0277 0.307816 33.1189 0.793217 32.811 1.2431L30.8039 2.13103C43.3829 7.56516 47.956 23.9504 40.1782 35.6593C33.9058 45.095 21.6234 48.2324 11.8499 42.6798C11.2226 42.3247 9.35231 41.4367 10.2304 40.5488C11.1086 39.6609 11.8841 40.9987 12.4885 41.3183C27.6905 49.6649 45.3102 36.4998 42.231 18.9543C41.0107 12.0285 36.2665 5.94321 29.9599 3.37413C29.8573 3.48069 30.6442 5.26838 30.6898 5.58804C30.8381 6.547 29.7319 6.96137 29.2643 5.99057C28.7967 5.01976 28.1353 3.0308 28.0326 2.40333C27.93 1.77586 27.9414 1.91793 28.0326 1.69299C28.2607 1.18391 31.3285 0.449885 31.9101 0.0118391H32.5943L32.6058 0Z"
      fill={color}
    />
    <path
      d="M26.3979 9.89426C27.521 10.2524 28.5621 10.8069 29.5799 11.373C30.1765 11.0957 31.4634 9.66322 32.0366 9.64011C32.6098 9.61701 33.066 10.1831 33.3936 10.4719C34.3412 11.2921 35.3706 12.5051 36.0725 13.5333C36.7745 14.5614 37.1254 15.1159 37.2658 15.5549C37.4062 15.9939 37.3711 15.9939 37.3126 16.2481C37.1956 16.7333 35.0548 17.9809 35.0665 18.2351L35.8854 21.5852C36.014 21.7239 38.0847 22.0358 38.4941 22.2091C38.9036 22.3824 39.0206 22.8098 38.9972 23.2719C38.927 25.0278 38.2602 28.8401 37.2307 30.2611C36.2012 31.682 34.7038 29.8683 33.7913 30.1455C33.2415 31.139 32.4694 31.9824 31.6739 32.7795C31.9196 33.5188 33.1128 35.0091 32.8087 35.7369C32.4694 36.5571 28.8078 38.3015 27.8602 38.6365C26.9126 38.9715 25.462 39.5607 25.0058 38.9946C24.725 38.6481 23.9529 36.6264 23.836 36.5571H20.2328C20.0924 36.5686 19.2735 38.8098 18.946 39.0871C18.6184 39.3643 17.6943 39.1102 17.2146 38.9831C15.6587 38.5556 13.8923 37.7354 12.5586 36.8343C11.225 35.9333 11.2016 35.9679 11.1548 35.5405C11.0729 34.8589 12.1258 33.4726 12.3598 32.7795C11.9503 32.352 11.5292 31.9362 11.1548 31.4856C10.7805 31.0351 10.2657 30.1455 10.1955 30.0993C9.84459 29.8798 7.65697 30.8733 7.04865 30.5268C6.44033 30.1802 5.84371 28.043 5.67993 27.4654C5.43427 26.5759 5.21199 25.4899 5.10671 24.5658C5.00142 23.6416 4.96633 23.1217 5.03652 22.7751C5.10671 22.4286 5.23539 22.3361 5.45766 22.2322C5.89051 22.0242 7.97283 21.7585 8.13661 21.5852L8.9555 18.1773L6.86148 16.5253C6.65091 16.2943 6.65091 15.9592 6.7094 15.682C6.76789 15.4047 7.61018 14.0531 7.84415 13.695C8.56945 12.6091 9.63401 11.3383 10.6284 10.4834C11.6228 9.62856 11.6578 9.47838 12.2662 9.73253C12.8745 9.98668 14.1847 11.3845 14.4304 11.3961C15.4598 10.83 16.4893 10.2755 17.6124 9.91737C17.7177 9.75563 17.5539 7.66466 17.6241 7.21412C17.6943 6.76358 17.8814 6.71737 18.1622 6.62495C19.332 6.19751 21.9174 6.1513 23.1808 6.22062C24.4443 6.28993 25.3685 6.42856 25.8949 6.64805C26.4213 6.86755 26.3277 6.95997 26.3628 7.22567C26.433 7.67621 26.2809 9.77874 26.3745 9.92892L26.3979 9.89426ZM24.8888 7.93036C23.0288 7.52603 21.04 7.54914 19.1683 7.90726C18.946 8.6004 19.3905 10.4603 18.8992 10.9455C18.4079 11.4307 16.9806 11.6964 16.4893 11.9275C15.764 12.274 14.7345 13.256 13.9858 12.9325C13.2371 12.6091 12.4182 11.5116 12.0205 11.4076C11.6228 11.3037 11.6345 11.5694 11.4941 11.6733C10.2306 12.6899 9.08419 14.3997 8.33548 15.8206C8.89701 16.3405 9.85629 16.8488 10.3593 17.3802C10.8624 17.9116 10.3359 18.6394 10.1604 19.2632C10.0552 19.6213 9.94987 20.0026 9.87968 20.3607C9.751 20.9961 9.7627 21.8163 9.62232 22.3477C9.48193 22.8791 9.43514 22.7174 9.22457 22.8213C8.81512 23.0293 6.59241 23.3643 6.51052 23.4683C6.62751 24.3925 6.6977 25.3167 6.90827 26.2408C7.11884 27.165 7.4464 28.0892 7.82075 28.9672C8.54606 29.0481 10.3476 28.1701 10.9325 28.5629C11.5175 28.9556 11.9854 30.134 12.2896 30.5152C12.5937 30.8964 13.8923 32.1441 13.9274 32.2596C14.1847 33.0798 12.6756 34.9629 12.8394 35.2286C14.407 36.326 16.1735 37.204 18.0452 37.643C18.3611 37.1116 18.9226 35.321 19.4256 35.0668C19.9287 34.8127 20.7944 35.1246 21.3325 35.1477C22.3152 35.1939 23.1457 34.986 24.0465 34.9629C24.9473 34.9398 25.4152 36.9268 25.9885 37.6546C27.8602 37.1463 29.6501 36.3376 31.1826 35.1708C31.2177 35.0437 30.1531 33.1838 30.0478 32.7564C29.9425 32.3289 30.0127 32.352 30.1414 32.1441C30.3988 31.7282 31.323 31.0004 31.7207 30.5037C32.1185 30.0069 32.8906 28.6553 33.1362 28.5282C33.7212 28.2047 35.9322 29.152 36.2012 28.9672C36.5756 28.0892 36.9148 27.1766 37.1137 26.2408C37.3126 25.3051 37.3711 24.3925 37.5115 23.4683C37.3828 23.3065 34.9495 23.0639 34.5868 22.6827C34.271 22.3593 34.4114 21.9665 34.3646 21.6083C34.2476 20.8112 34.0838 20.0257 33.8615 19.2517C33.6861 18.6509 33.1479 17.9694 33.6159 17.4148L35.6748 15.8553C35.9088 15.5318 32.7502 11.4885 32.1185 11.3845C31.4867 11.2805 30.4456 12.7592 30.0361 12.9325C29.6267 13.1058 29.7203 13.0365 29.498 13.0134C29.1354 12.9787 27.9421 12.1239 27.4742 11.8928C27.0062 11.6618 25.7311 11.3383 25.2632 11.0495C24.7952 10.7607 24.9473 10.7376 24.9122 10.5296C24.842 10.0791 25.0058 8.06899 24.9005 7.90726L24.8888 7.93036Z"
      fill={color}
    />
    <path
      d="M7.22059 37.6008V35.2334C7.22059 34.7312 8.44055 34.3964 8.63438 35.2693C8.82821 36.1421 8.74839 38.7726 8.66858 39.4421C8.62298 39.8606 8.34934 40.1476 7.93888 40.2073C6.6049 40.3747 4.96308 40.0997 3.6063 40.1834C3.11603 40.0639 2.93361 39.4063 3.19584 38.9878C3.45808 38.5693 3.53789 38.6769 3.5835 38.6769H6.10324C3.13884 35.4247 1.09796 31.3116 0.345457 26.8637C-1.98046 13.2212 7.72226 0.547188 20.9138 0.00913949C21.9058 -0.0267304 24.5623 0.0330527 25.4403 0.367839C26.3182 0.702624 26.0673 1.67111 25.349 1.79068C24.6307 1.91024 23.3082 1.5635 22.5329 1.52763C13.8335 1.14502 5.68138 6.94399 2.69418 15.4571C0.0262141 23.0496 1.73645 31.9214 7.22059 37.6128V37.6008Z"
      fill={color}
    />
    <path
      d="M20.9567 14.5063C29.9302 13.561 33.4256 25.6016 25.8617 29.9144C19.5012 33.542 12.2239 27.2322 14.3899 20.1189C15.2609 17.2358 17.9999 14.8135 20.9567 14.5063ZM21.0484 16.0069C18.7105 16.2787 16.4872 18.2992 15.7881 20.5797C14.0232 26.3223 19.7992 31.4269 25.0137 28.6737C31.3856 25.3062 28.5664 15.1325 21.0484 16.0069Z"
      fill={color}
    />
    <path
      d="M25.1734 19.6296C25.8401 19.4936 26.2773 20.3552 25.7964 20.8767C24.3974 22.1465 23.1296 23.9265 21.7088 25.1282C20.288 26.33 21.0093 25.6384 20.5284 25.3323C20.0694 24.6634 18.3207 23.3596 18.0693 22.7134C17.8179 22.0671 18.2879 21.5343 18.8781 21.7043C19.4683 21.8744 20.8344 23.7677 20.9765 23.7677L24.6925 19.9017C24.8237 19.7997 25.0095 19.6523 25.1625 19.6183L25.1734 19.6296Z"
      fill={color}
    />
  </svg>
);

// Used in: CvAnalysisModal.tsx and FunnelModal.tsx close buttons
export const CloseIcon = ({
  className = "w-6 h-6",
}: {
  className?: string;
}) => (
  <LineIcon className={className} strokeWidth={2}>
    <path d="M6 6l12 12M18 6L6 18" />
  </LineIcon>
);

// Used in: ApplicantsClient.tsx back button
export const BackArrowIcon = ({
  className = "w-5 h-5",
}: {
  className?: string;
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 19l-7-7m0 0l7-7m-7 7h18"
    />
  </svg>
);

// Used in: ApplicantsClient.tsx for CV analyzed status
export const CheckmarkIcon = ({
  className = "w-4 h-4",
}: {
  className?: string;
}) => (
  <LineIcon className={className} strokeWidth={2.6}>
    <path d="m5 12 4.5 4.5L19 7" />
  </LineIcon>
);

// Used in: ApplicantsClient.tsx for pending/inbound status
export const ClockIcon = ({
  className = "w-4 h-4",
}: {
  className?: string;
}) => (
  <LineIcon className={className}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </LineIcon>
);

// Dashboard Icons - Used in: /app/dashboard/DashboardClient.tsx

export const LoadingSpinnerIcon = ({
  className = "",
}: {
  className?: string;
}) => (
  // Used in: DashboardClient.tsx - Loading state for action buttons
  <svg className={`animate-spin ${className}`} fill="none" viewBox="0 0 24 24">
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

export const DeleteIcon = ({ className = "" }: { className?: string }) => (
  // Used in: DashboardClient.tsx - Delete job button
  <LineIcon className={className}>
    <path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3" />
  </LineIcon>
);

export const ChangeOwnerIcon = ({ className = "" }: { className?: string }) => (
  // Used in: DashboardClient.tsx - Change owner button (admin only)
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth={2.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 14c-4 0-7 2-7 4v2h10"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 16l-2 2m0 0l2 2m-2-2h4"
    />
  </svg>
);

export const ApplicantsIcon = ({ className = "" }: { className?: string }) => (
  // Used in: DashboardClient.tsx - View applicants button
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth={2.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);

export const EditIcon = ({ className = "" }: { className?: string }) => (
  // Used in: DashboardClient.tsx - Edit job button
  <LineIcon className={className}>
    <path d="M4 20h4L19 9l-4-4L4 16z" />
    <path d="M13.5 6.5l4 4" />
  </LineIcon>
);

export const ExternalLinkIcon = ({
  className = "",
}: {
  className?: string;
}) => (
  // Used in: DashboardClient.tsx - External link button (published jobs)
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth={2.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
    />
  </svg>
);

export const RejectCircleIcon = ({
  className = "w-5 h-5",
}: {
  className?: string;
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth={2.2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 22a10 10 0 100-20 10 10 0 000 20z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 9l6 6m0-6l-6 6" />
  </svg>
);
export const PersonIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
  >
    <path
      d="M10.5309 0.0242366C13.1825 0.258776 15.4478 2.70971 15.6234 5.33655C16.0038 10.9772 9.06168 13.821 5.39158 9.49962C1.72149 5.17823 4.65991 0.440544 9.12606 0.0242366C9.48898 -0.0109443 10.1621 -0.00508077 10.5309 0.0242366Z"
      fill="white"
    />
    <path
      d="M4.77112 11.6046C6.02961 11.4991 6.59739 12.3727 7.64515 12.8653C9.30167 13.6392 10.9699 13.5923 12.5854 12.7421C13.4693 12.2789 14.0429 11.5225 15.1317 11.5929C18.0467 11.7922 19.3286 14.466 19.7676 17.0166C20.3178 20.1887 20.1598 23.5485 16.2555 24H3.72921C0.141068 23.5602 -0.268671 20.7809 0.117654 17.7085C0.457152 14.9937 1.63954 11.8743 4.77698 11.6046H4.77112Z"
      fill="white"
    />
  </svg>
);
export const LoginBriefIcon = () => (
  <svg
    width="24"
    height="17"
    viewBox="0 0 24 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.151367 4.74179C0.302696 4.77454 0.436564 4.86732 0.564612 4.94373C4.18487 7.01224 7.78766 9.09712 11.4137 11.1602C11.7106 11.3239 12.0831 11.3075 12.4148 11.253C16.0875 9.26631 19.6728 7.13231 23.2989 5.07471C23.5026 4.9601 23.718 4.8182 23.9449 4.74179V13.6981C23.9449 14.8769 22.3909 16.3342 21.157 16.487C15.1213 16.6016 9.05068 16.5743 3.01498 16.4979C1.74614 16.2632 0.669378 15.3791 0.291056 14.2165L0.151367 13.7199V4.74179Z"
      fill="#E6E6E6"
    />
    <path
      d="M3.30017 0.0917358H20.7554C22.2629 0.233639 23.5375 1.26516 23.846 2.66782L12.0714 9.4355L0.267774 2.69511C0.500588 1.30883 1.83927 0.239097 3.306 0.0917358H3.30017Z"
      fill="#E6E6E6"
    />
  </svg>
);

export const LoginLockIcon = () => (
  <svg
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.47939 23.8601C1.60569 23.6284 0.965342 22.9898 0.813395 22.0459V11.5057C0.769981 10.7089 1.75764 9.56159 2.5011 9.56159H3.55388C3.62443 7.84351 3.30968 6.09152 3.96088 4.46951C5.81681 -0.147834 12.1878 -0.193047 14.098 4.40734C14.9123 6.36844 14.4615 7.8096 14.5321 9.56159H15.5849C16.3283 9.56159 17.3214 10.7089 17.2834 11.5057V22.0459C17.1206 22.9841 16.4857 23.634 15.6066 23.8601H2.47939ZM12.687 9.56159V6.36844C12.687 4.57124 10.8474 2.97184 9.19222 2.90402C7.41769 2.83055 5.39353 4.44125 5.39353 6.36844V9.56159H12.687Z"
      fill="#D9D9D9"
    />
  </svg>
);
export const CompanyBriefCase = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.57692 6.10953C8.57692 5.41588 8.85247 4.75065 9.34295 4.26017C9.83343 3.76969 10.4987 3.49414 11.1923 3.49414H13.8077C14.5013 3.49414 15.1666 3.76969 15.657 4.26017C16.1475 4.75065 16.4231 5.41588 16.4231 6.10953V6.28824C17.2365 6.36235 18.042 6.45999 18.8414 6.57942C20.109 6.76947 21 7.87229 21 9.12245V11.7666C21 12.8223 20.3601 13.8171 19.3122 14.1658C17.1151 14.8951 14.8149 15.2657 12.5 15.2634C10.12 15.2634 7.82979 14.878 5.68779 14.1658C4.6399 13.8171 4 12.8223 4 11.7666V9.12245C4 7.87229 4.89097 6.7686 6.15856 6.57942C6.96174 6.45931 7.76819 6.36221 8.57692 6.28824V6.10953ZM15.1154 6.10953V6.18799C13.3734 6.08219 11.6266 6.08219 9.88462 6.18799V6.10953C9.88462 5.7627 10.0224 5.43009 10.2676 5.18485C10.5129 4.93961 10.8455 4.80183 11.1923 4.80183H13.8077C14.1545 4.80183 14.4871 4.93961 14.7324 5.18485C14.9776 5.43009 15.1154 5.7627 15.1154 6.10953Z"
      fill="#F6F5F7"
    />
    <path
      d="M4.65381 17.5733V15.1357C4.85242 15.2444 5.06047 15.3349 5.2754 15.406C7.60543 16.1796 10.0449 16.5729 12.5 16.5707C15.0212 16.5707 17.4518 16.1627 19.7245 15.4069C19.9442 15.3336 20.1517 15.2421 20.3461 15.1357V17.5733C20.3461 18.8391 19.4333 19.9515 18.1466 20.1215C16.2984 20.3674 14.4136 20.4938 12.5 20.4938C10.6116 20.4942 8.7253 20.3698 6.85335 20.1215C5.56658 19.9515 4.65381 18.8391 4.65381 17.5733Z"
      fill="#F6F5F7"
    />
  </svg>
);
export const FirstPointingArray = () => (
  <svg
    width="145"
    height="95"
    viewBox="0 0 145 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00025 88.0499C2.00025 88.0499 29.4059 68.6323 30.9285 57.467C32.4509 46.3024 20.3329 48.0011 23.8992 57.5628C27.4652 67.1251 37.3878 68.3159 44.5669 66.0053C68.844 58.1921 76.2476 26.2891 69.103 14.5415C64.7487 7.38198 54.7189 7.25458 50.641 20.7864C41.3398 51.6504 65.5414 92.9916 91.259 92.6236C116.052 92.2684 117.737 62.2249 125.791 35.4997C133.845 8.7744 140.632 2.14771 140.632 2.14771M140.632 2.14771C140.632 2.14771 133.589 4.37982 128.806 4.96808M140.632 2.14771C140.632 2.14771 141.26 9.91292 142.605 14.0084"
      stroke="#EEEBF0"
      strokeWidth="3"
      strokeMiterlimit="16"
      strokeLinecap="round"
    />
  </svg>
);
export const AboutUsCardIcon = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 84 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M63.422 41.8578H79.8691C81.6463 41.8578 84.013 44.5084 83.9999 46.3111V75.5402C83.7336 77.893 81.7598 79.8717 79.3691 80L36.3485 79.9913C34.6215 80.087 31.877 77.7016 31.877 76.0447V64.5374C16.8098 64.57 3.31893 53.1889 0.578832 38.5026C-3.86645 14.6814 18.0128 -5.34977 41.4925 1.28669C58.743 6.16183 68.7406 24.7513 63.422 41.8578ZM60.5552 41.8578C66.2341 25.3123 56.0925 7.20122 38.9947 3.43723C16.6788 -1.47271 -2.56081 19.1499 4.00013 40.9793C7.61793 53.0149 19.194 61.8324 31.8792 61.8498V55.633C25.4908 55.3438 19.253 52.5844 15.0151 47.8158C3.61804 34.993 9.62442 14.5857 26.1065 9.98453C43.1605 5.22463 58.8675 20.1436 55.2432 37.3219C54.9135 38.8831 54.3458 40.3661 53.8087 41.8556H60.5552V41.8578ZM47.0862 41.8295C47.8678 41.7556 50.5315 42.1405 50.9245 41.5903C51.1559 41.2685 51.7891 39.5681 51.9529 39.0875C57.2933 23.3422 42.9597 8.17538 26.8553 12.5808C16.5522 15.3989 10.2161 25.8777 12.2182 36.3194C12.8274 39.5007 14.2553 42.5275 16.2749 45.0477L18.0761 41.3011C20.087 37.9959 23.2048 35.2083 26.9842 34.1276C25.6239 32.7055 24.3554 31.466 23.7747 29.5155C21.1677 20.7894 31.3727 13.9638 38.2895 19.7631C42.8985 23.6271 42.4575 30.4005 37.9511 34.1276C41.8374 35.2518 45.2522 38.259 47.0862 41.8295ZM31.6718 20.4002C23.6611 21.3113 24.6218 33.6775 32.9731 33.1186C41.3353 32.5576 40.4052 19.4086 31.6718 20.4002ZM43.8548 41.8578C43.7981 41.4881 43.416 41.0598 43.1758 40.7706C37.1389 33.497 25.2855 34.4146 20.4887 42.5275C19.9276 43.4778 18.3687 46.796 18.8054 47.7354C18.9495 48.0463 21.2442 49.6097 21.7048 49.8902C24.6917 51.7059 28.3531 52.8649 31.877 52.7779V45.8066C31.877 44.2845 34.497 41.8578 36.0101 41.8578H43.8548ZM36.3878 44.5867C35.3966 44.7694 34.7066 45.4696 34.5713 46.4742L34.5669 75.214C34.6171 76.473 35.604 77.2863 36.8463 77.3124C51.1821 77.1906 65.5725 77.5233 79.8756 77.1449C80.5306 76.8905 80.9542 76.4187 81.1878 75.7642C81.3472 65.8638 81.4389 55.8548 81.1398 45.9653C80.8843 45.313 80.4105 44.8912 79.7533 44.6585L36.3856 44.5846L36.3878 44.5867Z"
      fill="white"
    />
    <path
      d="M62.0465 62.3803L40.2305 62.3499C37.8638 62.2368 37.8681 59.6101 40.2305 59.4992L61.9591 59.5035C63.1578 56.2658 67.4983 55.4438 69.6619 58.238C69.913 58.562 70.1445 59.3665 70.4479 59.4709C71.889 59.7405 76.177 58.9751 77.0897 60.0798C77.5154 60.5951 77.4521 61.367 76.9914 61.8433C76.0046 62.8631 71.8911 62.1042 70.4479 62.3825C70.1445 62.4869 69.913 63.2893 69.6619 63.6154C67.5681 66.3139 63.1425 65.6616 62.0443 62.3825L62.0465 62.3803ZM65.566 59.3665C64.0377 59.7145 64.0398 62.476 66.0354 62.5369C68.6227 62.6152 68.3498 58.7316 65.566 59.3665Z"
      fill="white"
    />
    <path
      d="M59.064 68.8798L76.1487 68.9168C77.8298 69.3103 77.7185 71.3957 75.9936 71.6001L59.1492 71.5892C57.54 75.5924 52.2105 75.6707 50.6581 71.5892L39.7152 71.6022C38.1563 71.4131 38.0624 69.2973 39.5624 68.9168H50.6691C52.0424 64.8897 57.6623 64.8614 59.064 68.8798ZM54.4353 68.6015C52.5598 69.0103 52.8961 72.272 55.1973 71.8936C57.3392 71.5414 56.7868 68.0905 54.4353 68.6015Z"
      fill="white"
    />
    <path
      d="M52.228 48.4703C52.6472 48.8813 53.1624 50.186 53.5511 50.2621L76.5351 50.386C77.8669 51.1014 77.4892 52.7757 75.9915 52.9497L53.5489 52.9432C53.1624 53.0193 52.645 54.324 52.2258 54.7349C49.8983 57.0181 45.905 56.0048 44.9291 52.9367C43.3483 52.7366 40.7501 53.2868 39.3026 52.8497C38.141 52.5018 38.2437 50.4773 39.5602 50.2686C40.3746 50.1403 44.809 50.4186 45.0142 50.2382C45.8723 47.1417 49.9355 46.2219 52.2258 48.4681L52.228 48.4703ZM48.6997 49.9533C46.7565 50.3817 47.2106 53.5238 49.3198 53.2759C51.5926 53.0084 51.0839 49.4271 48.6997 49.9533Z"
      fill="white"
    />
  </svg>
);
export const AboutUsShieldIcon = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 84 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.1972 101.001H41.0384C29.1421 96.8597 18.0852 90.1692 10.7343 79.5629C-0.706046 63.0606 -0.406896 41.8332 0.272726 22.411C0.339526 20.4605 -0.186164 17.5703 0.955252 16.0051C2.42777 13.9864 5.37279 14.7601 7.51041 14.6089C18.0358 13.8708 27.4518 10.9184 35.7205 4.15086C37.286 2.87028 39.4991 0.0512163 41.5205 0.000823013C43.7308 -0.0554989 45.8597 2.7932 47.5151 4.15382C55.749 10.9213 65.2376 13.8768 75.7253 14.6119C77.8629 14.7631 80.8079 13.9894 82.2804 16.0081C83.416 17.5644 82.8903 20.2915 82.9629 22.2154C83.6629 41.4982 83.9388 63.0428 72.5769 79.4503C65.2463 90.0329 54.0674 96.8834 42.1943 101.004L42.1972 101.001Z"
      fill="#007AFF"
    />
    <path
      d="M24.3682 51.7937L37.505 65L63.3682 39"
      stroke="white"
      strokeWidth="8"
      strokeLinecap="round"
    />
  </svg>
);
export const AboutUsGoogleIcon = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 447 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M405.106 42.4236C402.07 42.4236 399.647 41.6941 397.835 40.2351C396.046 38.7762 395.034 36.7289 394.799 34.0934H400.553C400.694 35.1758 401.164 36.0347 401.964 36.6701C402.788 37.3054 403.835 37.6231 405.106 37.6231C406.471 37.6231 407.577 37.1642 408.424 36.2465C409.271 35.3052 409.695 34.0934 409.695 32.6109C409.695 31.199 409.248 30.0224 408.353 29.0811C407.459 28.1163 406.318 27.6339 404.929 27.6339C404.012 27.6339 403.188 27.8222 402.459 28.1987C401.729 28.5752 401.153 29.1046 400.729 29.7871H395.823L397.693 13.409H413.754V18.4565H402.388L401.682 24.5983H401.859C402.376 24.1041 403.023 23.7159 403.8 23.4335C404.6 23.1511 405.518 23.0099 406.553 23.0099C408.295 23.0099 409.801 23.41 411.071 24.21C412.365 25.0101 413.377 26.1043 414.107 27.4927C414.86 28.8575 415.236 30.4224 415.236 32.1873C415.236 34.2816 414.801 36.0935 413.93 37.6231C413.083 39.1527 411.895 40.341 410.365 41.1882C408.859 42.0118 407.106 42.4236 405.106 42.4236ZM420.24 42.4236C419.252 42.4236 418.405 42.0824 417.699 41.3999C417.016 40.694 416.675 39.8469 416.675 38.8585C416.675 37.8702 417.016 37.0348 417.699 36.3524C418.405 35.6464 419.252 35.2935 420.24 35.2935C421.229 35.2935 422.064 35.6464 422.746 36.3524C423.452 37.0348 423.805 37.8702 423.805 38.8585C423.805 39.8469 423.452 40.694 422.746 41.3999C422.064 42.0824 421.229 42.4236 420.24 42.4236ZM435.341 42.4236C432.07 42.4236 429.575 41.1764 427.857 38.682C426.163 36.1877 425.316 32.5285 425.316 27.7045C425.316 22.8805 426.163 19.2213 427.857 16.727C429.575 14.2326 432.07 12.9854 435.341 12.9854C438.611 12.9854 441.094 14.2326 442.788 16.727C444.506 19.2213 445.365 22.8805 445.365 27.7045C445.365 32.5285 444.506 36.1877 442.788 38.682C441.094 41.1764 438.611 42.4236 435.341 42.4236ZM435.341 37.4819C436.823 37.4819 437.905 36.7054 438.588 35.1523C439.294 33.5757 439.647 31.0931 439.647 27.7045C439.647 24.3159 439.294 21.8451 438.588 20.292C437.905 18.7154 436.823 17.9271 435.341 17.9271C433.882 17.9271 432.799 18.7154 432.093 20.292C431.387 21.8451 431.034 24.3159 431.034 27.7045C431.034 31.0931 431.387 33.5757 432.093 35.1523C432.799 36.7054 433.882 37.4819 435.341 37.4819Z"
      fill="#DFE0E1"
    />
    <path
      d="M47.9179 21.6836C41.4048 21.6951 36.403 26.7702 36.4209 33.3486C36.4389 39.8974 41.4799 44.928 48.0207 44.9115C54.5255 44.8967 59.5535 39.7986 59.5274 33.2449C59.5012 26.6911 54.4619 21.6704 47.9179 21.6836ZM50.4865 39.7723C48.0484 40.8673 45.7425 40.431 43.7401 38.669C41.147 36.3834 40.7194 31.9934 42.7463 29.0525C43.3035 28.2284 44.0444 27.5477 44.9096 27.065C45.7749 26.5823 46.7402 26.3111 47.7281 26.2731C48.7161 26.2352 49.6991 26.4316 50.5981 26.8465C51.4972 27.2614 52.2873 27.8833 52.905 28.6622C53.9217 29.9203 54.4504 31.5142 54.4488 33.8624C54.3525 36.2369 53.2102 38.5472 50.4865 39.7723Z"
      fill="#DB4437"
    />
    <path
      d="M73.0668 21.6777C66.5114 21.6876 61.4801 26.7627 61.4981 33.3691C61.5112 39.8883 66.5783 44.9254 73.1125 44.9172C79.5929 44.9089 84.6257 39.8586 84.6323 33.3642C84.6371 26.7429 79.6141 21.6695 73.0668 21.6777ZM72.2313 40.2653C69.7654 39.9871 67.6619 38.0917 66.8932 35.4653C65.9141 32.1127 67.3012 28.4884 70.1196 27.0179C74.2092 24.8772 79.0119 27.6057 79.495 32.3366C79.5276 32.666 79.5341 32.9953 79.539 33.0875C79.5374 37.629 76.2784 40.7231 72.2313 40.2653Z"
      fill="#F4B400"
    />
    <path
      d="M125.186 36.8025C130.269 34.6783 135.356 32.5525 140.535 30.3904C140.137 29.4683 139.829 28.6466 139.44 27.8644C136.516 22.0056 130.227 19.9357 124.791 23.1319C121.225 25.2298 119.634 28.5791 119.405 32.6398C118.93 41.4231 127.211 47.3758 135.214 44.0117C137.316 43.1274 138.967 41.6717 140.289 39.7649L136.372 37.1467C133.151 41.9714 126.746 40.8764 125.186 36.8025ZM128.89 26.3907C131.191 25.732 133.569 26.6508 134.533 28.6466L124.329 32.9279C124.076 29.9936 126.067 27.1975 128.89 26.3907Z"
      fill="#DB4437"
    />
    <path
      d="M34.5702 25.2284H33.64C28.8813 25.2284 24.1226 25.2284 19.3639 25.2284C19.0669 25.2284 18.7715 25.2663 18.4745 25.286H18.3113C18.2657 25.3124 18.1824 25.3371 18.1824 25.3651C18.1612 26.8767 18.1416 28.39 18.1531 29.9033C18.1531 29.9741 18.4435 30.0416 18.5986 30.1108C18.7857 30.1397 18.9741 30.159 19.1632 30.1684C22.6882 30.1684 26.2142 30.1684 29.7414 30.1684C29.4933 33.2971 28.1584 35.8033 25.6387 37.6854C20.4051 41.5979 10.2562 40.9277 6.50928 32.3058C4.33718 27.3081 4.97037 22.4801 8.4937 18.2844C11.9664 14.1463 17.3877 12.7022 22.3226 14.5184C23.9741 15.1261 25.4641 16.175 26.9279 16.9687L30.3647 13.7198C30.3647 13.7198 30.1167 13.5337 30.0204 13.4432C23.7473 7.57774 14.114 7.22865 7.07066 12.6198C-1.39087 19.1028 -2.42877 31.354 4.88225 39.1213C9.18726 43.6941 14.5465 45.4923 20.7119 44.8007C27.5497 44.0333 32.8763 39.2811 34.3776 32.7174C34.9522 30.2611 35.0178 27.7115 34.5702 25.2284Z"
      fill="#4285F4"
    />
    <path
      d="M108.687 22.4427H103.94C103.914 23.029 103.891 23.5789 103.862 24.231L102.86 23.4637L101.717 22.693C99.5696 21.486 97.2996 21.4086 94.9986 22.0623C90.6103 23.3072 87.2224 27.2823 86.7688 31.8271C86.2645 36.861 88.1657 40.7998 92.4511 43.4476C95.9516 45.6097 100.74 45.5422 103.679 42.4596C103.703 42.4349 103.775 42.4596 103.842 42.4596C103.842 43.4147 103.924 44.3731 103.827 45.3117C103.542 48.0731 102.079 49.8614 99.6708 50.5217C97.1005 51.2265 94.5335 50.3834 92.9684 48.2888C92.5947 47.7948 92.2945 47.2366 91.924 46.6422L87.6092 48.4535C90.0408 54.3387 96.4053 56.7791 102.2 54.5462L104.903 52.9703C104.911 52.9725 104.92 52.9729 104.928 52.9714C104.937 52.97 104.945 52.9668 104.952 52.9619C104.959 52.9571 104.966 52.9509 104.97 52.9435C104.975 52.9362 104.978 52.9279 104.979 52.9193L105.13 52.7793L105.293 52.6146L105.844 52.0334L105.836 52.0136C106.251 51.4817 106.732 50.9894 107.065 50.4098C108.268 48.3168 108.717 46.0181 108.718 43.6189C108.718 36.7622 108.718 29.9049 108.718 23.0471C108.723 22.8659 108.702 22.6782 108.687 22.4427ZM103.638 36.5003C102.532 39.1943 100.141 40.5775 97.3355 40.2762C94.7538 39.9995 92.505 37.8473 91.9224 35.0661C91.8 34.4815 91.7592 33.8772 91.7151 33.4886C91.8114 30.737 92.7237 28.6293 94.8974 27.223C95.5403 26.7951 96.2611 26.5006 97.0179 26.3565C97.7747 26.2123 98.5524 26.2215 99.3056 26.3835C100.059 26.5455 100.773 26.857 101.406 27.2999C102.038 27.7429 102.578 28.3084 102.992 28.9635C104.518 31.3413 104.705 33.9003 103.638 36.5003Z"
      fill="#4285F4"
    />
    <path
      d="M112.134 10.0605V44.1762H117.111V10.0605H112.134Z"
      fill="#0F9D58"
    />
    <path
      d="M186.469 9.76758L191.639 20.7745L203.197 22.5415L194.833 31.1128L196.806 43.2196L186.469 36.909L176.132 42.6266L178.105 30.5198L169.741 22.5415L181.299 20.7745L186.469 9.76758Z"
      fill="#FDD264"
    />
    <path
      d="M226.643 9.76758L231.813 20.7745L243.371 22.5415L235.007 31.1128L236.98 43.2196L226.643 36.909L216.306 42.6266L218.279 30.5198L209.915 22.5415L221.473 20.7745L226.643 9.76758Z"
      fill="#FDD264"
    />
    <path
      d="M266.813 9.76758L271.983 20.7745L283.541 22.5415L275.177 31.1128L277.15 43.2196L266.813 36.909L256.476 42.6266L258.449 30.5198L250.085 22.5415L261.643 20.7745L266.813 9.76758Z"
      fill="#FDD264"
    />
    <path
      d="M306.985 9.76758L312.155 20.7745L323.713 22.5415L315.349 31.1128L317.322 43.2196L306.985 36.909L296.647 42.6266L298.621 30.5198L290.257 22.5415L301.815 20.7745L306.985 9.76758Z"
      fill="#FDD264"
    />
    <path
      d="M347.154 9.76758L352.324 20.7745L363.882 22.5415L355.518 31.1128L357.491 43.2196L347.154 36.909L336.816 42.6266L338.79 30.5198L330.426 22.5415L341.984 20.7745L347.154 9.76758Z"
      fill="#FDD264"
    />
  </svg>
);

export const RocketIcon = ({ color = "#0147C0" }: { color?: string }) => (
  <LineIcon className="w-4 h-4" color={color}>
    <path d="M5 15c-1.5 1.5-2 5-2 5s3.5-.5 5-2" />
    <path d="M9 15l-3-3c1-4 4.5-8 12-9-1 7.5-5 11-9 12z" />
    <circle cx="14.5" cy="9.5" r="1.5" />
  </LineIcon>
);

export const UploadIcon = ({
  color = "#111111",
  className,
}: {
  color?: string;
  className?: string;
}) => (
  <LineIcon className={className} color={color}>
    <path d="M12 3v12M7 8l5-5 5 5" />
    <path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" />
  </LineIcon>
);
export const PhotoIcon = ({
  color = "#111111",
  className,
}: {
  color?: string;
  className?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke={color}
    className={className}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    />
  </svg>
);
export const ProcessingIcon = ({
  color = "#111111",
  className,
}: {
  color?: string;
  className?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke={color}
    className={className}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    />
  </svg>
);

// Job Preview Tab Icons
export const JobEditorIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    viewBox="0 0 24 24"
    fill={fill}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 3.5h15A2.5 2.5 0 0 1 22 6v12a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 18V6a2.5 2.5 0 0 1 2.5-2.5ZM4.75 8.5h14.5a1 1 0 0 1 1 1v8.25a1 1 0 0 1-1 1H4.75a1 1 0 0 1-1-1V9.5a1 1 0 0 1 1-1ZM5.25 5a1 1 0 1 0 0 2a1 1 0 1 0 0-2ZM8.25 5a1 1 0 1 0 0 2a1 1 0 1 0 0-2ZM6.25 10.625h11.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H6.25a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75ZM6.25 15.125h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5Z"
      fill={fill}
    />
  </svg>
);

export const FunnelTabIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill={fill}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.5C0 3.35787 3.35787 0 7.5 0C11.6421 0 15 3.35787 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35787 15 0 11.6421 0 7.5ZM6.34275 8.45059C6.29427 8.66911 6.47986 8.86364 6.71448 8.86364H8.2095C8.38493 8.86364 8.53302 8.7512 8.59527 8.59507C8.65705 8.44016 8.87161 8.15959 9.03682 8.01259C9.19275 7.84855 9.35543 7.69418 9.51566 7.54214C10.1471 6.94295 10.7414 6.37909 10.7414 5.3935C10.7414 3.68387 9.26046 2.72727 7.68457 2.72727C6.47986 2.72727 4.81647 3.27685 4.48906 5.11611C4.42306 5.48684 4.73709 5.79545 5.11365 5.79545H6.07656C6.43555 5.79545 6.70309 5.50665 6.82643 5.16955C6.9452 4.84503 7.18493 4.60575 7.68457 4.60575C8.59541 4.60575 8.59527 5.60708 8.06905 6.26202C7.8705 6.50911 7.63793 6.72798 7.40782 6.94452C6.94077 7.38395 6.48395 7.81377 6.34275 8.45059ZM8.86357 10.9091C8.86357 11.6622 8.25307 12.2727 7.49993 12.2727C6.74686 12.2727 6.13632 11.6622 6.13632 10.9091C6.13632 10.156 6.74686 9.54545 7.49993 9.54545C8.25307 9.54545 8.86357 10.156 8.86357 10.9091Z"
      fill={fill}
    />
  </svg>
);

export const InstagramPreviewIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill={fill}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.125 0H0.875C0.391344 0 0 0.391344 0 0.875V13.125C0 13.6087 0.391344 14 0.875 14H13.125C13.6087 14 14 13.6087 14 13.125V0.875C14 0.391344 13.6087 0 13.125 0ZM2.625 3.5C2.14134 3.5 1.75 3.10866 1.75 2.625C1.75 2.14134 2.14134 1.75 2.625 1.75C3.10866 1.75 3.5 2.14134 3.5 2.625C3.5 3.10866 3.10866 3.5 2.625 3.5ZM11.375 3.5H5.25C4.76634 3.5 4.375 3.10866 4.375 2.625C4.375 2.14134 4.76634 1.75 5.25 1.75H11.375C11.8587 1.75 12.25 2.14134 12.25 2.625C12.25 3.10866 11.8587 3.5 11.375 3.5Z"
      fill={fill}
    />
  </svg>
);

export const SuccessPageIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill={fill}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.012 3.9759C14.11 3.9759 15 3.08587 15 1.98795C15 0.890039 14.11 0 13.012 0C11.9141 0 11.0241 0.890039 11.0241 1.98795C11.0241 3.08587 11.9141 3.9759 13.012 3.9759Z"
      fill={fill}
    />
    <path
      d="M12.3181 4.98795C11.1831 4.74217 10.2578 3.81687 10.012 2.68193C9.91807 2.24096 9.91084 1.81446 9.99036 1.40964C10.0843 0.961446 9.75181 0.542169 9.28916 0.542169H3.61446C1.61928 0.542169 0 2.16145 0 4.15663V9.18072C0 11.1759 1.61928 12.7952 3.61446 12.7952H4.69879C4.9012 12.7952 5.16145 12.9253 5.27711 13.0843L6.36144 14.5229C6.83855 15.159 7.61928 15.159 8.09638 14.5229L9.18072 13.0843C9.31807 12.9036 9.52771 12.7952 9.75904 12.7952H10.8506C12.8458 12.7952 14.4578 11.1831 14.4578 9.18795V5.71084C14.4578 5.25542 14.0386 4.92289 13.5904 5.00964C13.1855 5.08193 12.759 5.08193 12.3181 4.98795ZM4.33735 7.77108C3.93253 7.77108 3.61446 7.44578 3.61446 7.04819C3.61446 6.6506 3.93253 6.3253 4.33735 6.3253C4.73494 6.3253 5.06024 6.6506 5.06024 7.04819C5.06024 7.44578 4.74217 7.77108 4.33735 7.77108ZM7.22891 7.77108C6.8241 7.77108 6.50602 7.44578 6.50602 7.04819C6.50602 6.6506 6.8241 6.3253 7.22891 6.3253C7.62651 6.3253 7.95181 6.6506 7.95181 7.04819C7.95181 7.44578 7.63373 7.77108 7.22891 7.77108ZM10.1205 7.77108C9.71566 7.77108 9.39759 7.44578 9.39759 7.04819C9.39759 6.6506 9.71566 6.3253 10.1205 6.3253C10.5181 6.3253 10.8434 6.6506 10.8434 7.04819C10.8434 7.44578 10.5253 7.77108 10.1205 7.77108Z"
      fill={fill}
    />
  </svg>
);
export const VideoCameraIcon = ({
  className = "",
  fill = "#007AFF",
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill={fill}
    className={className}
  >
    <path d="M4.5 4.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3H4.5ZM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06Z" />
  </svg>
);

export const FacebookIcon = ({
  className = "",
  width = 20,
  height = 20,
}: {
  className?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width}
    height={height}
    className={className}
  >
    <path
      fill="#1877F2"
      d="M24 1C11.3 1 1 11.3 1 24c0 11.5 8.4 21 19.4 22.7V30.6h-5.8v-6.6h5.8v-5c0-5.7 3.4-8.9 8.6-8.9 2.5 0 5.1.4 5.1.4v5.6h-2.9c-2.8 0-3.7 1.8-3.7 3.6V24h6.3l-1 6.6h-5.3v16.1C38.6 45 47 35.5 47 24 47 11.3 36.7 1 24 1z"
    />
    <path
      fill="#FFFFFF"
      d="M33.3 30.6l1-6.6h-6.3v-4.3c0-1.8.9-3.6 3.7-3.6h2.9v-5.6s-2.6-.4-5.1-.4c-5.2 0-8.6 3.2-8.6 8.9v5h-5.8v6.6h5.8v16.1c1.2.2 2.4.3 3.6.3s2.4-.1 3.6-.3V30.6h5.2z"
    />
  </svg>
);

export const GoogleIcon = ({
  className = "",
  width = 20,
  height = 20,
}: {
  className?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width}
    height={height}
    className={className}
  >
    <path
      fill="#EA4335"
      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
    />
    <path
      fill="#4285F4"
      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
    />
    <path
      fill="#FBBC05"
      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
    />
    <path
      fill="#34A853"
      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
    />
  </svg>
);
